import { TTruckerItem } from 'context/reducers/truckers.type';
import { addHashToPropertyTracking } from './addHashInEventToTracking';

export const transformDataToTracking = (filteredDataSuggested: TTruckerItem[]): TTruckerItem[] =>
  filteredDataSuggested?.map((trucker) => {
    const { person, vehicle } = trucker;

    return {
      ...trucker,
      person: { ...person, id: addHashToPropertyTracking(person.id) },
      vehicle: { ...vehicle, id: addHashToPropertyTracking(vehicle.id) },
    };
  });
